import { render, staticRenderFns } from "./WinLoseReportByType.vue?vue&type=template&id=c8b572f0&scoped=true&"
import script from "./WinLoseReportByType.vue?vue&type=script&lang=js&"
export * from "./WinLoseReportByType.vue?vue&type=script&lang=js&"
import style0 from "./WinLoseReportByType.vue?vue&type=style&index=0&id=c8b572f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b572f0",
  null
  
)

export default component.exports